<template>
  <v-layout align-center justify-center row fill-height>
    <v-flex xs12 sm12 md10 lg6 xl6>
      <MessageBox id="boxSinEmpresas" :title="$t('message.errores.error.titulo')" type="error">
        <p>{{ $route.params.errorText }}</p>
        <template slot="actions"
          ><v-spacer></v-spacer>
          <Boton id="btnIrInicfio" tipo="danger" :onclick="clickHandler">{{
            $t('message.errores.error.volver')
          }}</Boton>
        </template>
      </MessageBox>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions } from 'vuex';
import { Boton, MessageBox } from '@/components';
export default {
  created() {
    this.quitLoading();
  },
  methods: {
    ...mapActions(['setLoading']),
    clickHandler() {
      this.$router.push({ name: 'login' });
    },
    quitLoading() {
      this.setLoading(false);
    }
  },
  components: {
    Boton,
    MessageBox
  }
};
</script>
